(() => {
  if (customElements.get('wnc-product-benefits')) return;

  const closeBenefits = (except) => {
    document.querySelectorAll('[data-wnc-benefits] details[open]').forEach((details) => {
      if (details !== except) details.open = false;
    });
  };

  document.addEventListener('click', (event) => {
    const rail = event.target.closest('[data-wnc-benefits]');
    if (!rail) closeBenefits();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const opened = document.querySelector('[data-wnc-benefits] details[open]');
    if (!opened) return;
    const focusWasInside = opened.contains(document.activeElement);
    closeBenefits();
    if (focusWasInside) opened.querySelector('summary')?.focus();
  });

  class WncProductBenefits extends HTMLElement {
    connectedCallback() {
      if (this.dataset.wncBenefitsReady) return;
      this.dataset.wncBenefitsReady = 'true';
      this.addEventListener('click', (event) => {
        event.stopPropagation();
        const summary = event.target.closest('summary');
        if (summary) closeBenefits(summary.closest('details'));
      });
      this.addEventListener('pointerdown', (event) => event.stopPropagation());
      this.addEventListener('touchstart', (event) => event.stopPropagation(), { passive: true });
    }
  }

  customElements.define('wnc-product-benefits', WncProductBenefits);
})();
